import { isApiClientError } from "./api-client-error";
import { isAxiosError, isNetworkError } from "./client";
export const TRANSIENT_RETRY_DELAYS_MS = [300, 800, 1500];
export const MAX_TRANSIENT_RETRIES = TRANSIENT_RETRY_DELAYS_MS.length;
function browserIsOffline() {
    return typeof navigator !== "undefined" && navigator.onLine === false;
}
export function classifyRequestFailure(error) {
    if (isApiClientError(error) && !isAxiosError(error.originalError)) {
        return typeof error.status === "number" && error.status >= 500 ? "serverUnavailable" : "other";
    }
    const source = isApiClientError(error) ? error.originalError : error;
    if (!isAxiosError(source) || source.code === "ERR_CANCELED")
        return "other";
    if (!isNetworkError(source))
        return (source.response?.status ?? 0) >= 500 ? "serverUnavailable" : "other";
    if (browserIsOffline())
        return "offline";
    return source.code === "ECONNABORTED" || source.code === "ETIMEDOUT" ? "timeout" : "offline";
}
export function isTransientRequestError(error) {
    return classifyRequestFailure(error) !== "other";
}
// WHY: react-query passes the 0-based count of failures so far; 4xx must never be retried.
export function shouldRetryTransientRequest(failureCount, error) {
    return failureCount < MAX_TRANSIENT_RETRIES && isTransientRequestError(error);
}
export function transientRetryDelay(failureCount) {
    return TRANSIENT_RETRY_DELAYS_MS[Math.min(failureCount, MAX_TRANSIENT_RETRIES - 1)] ?? 0;
}
export function requestAttemptCount(error) {
    return isTransientRequestError(error) ? MAX_TRANSIENT_RETRIES + 1 : 1;
}
export function requestFailureStatus(error) {
    if (isApiClientError(error))
        return error.status ?? requestFailureStatus(error.originalError);
    return isAxiosError(error) ? error.response?.status : undefined;
}
